import { applicationUrls } from 'src/app/shared/application-constants/application-urls.const';
import { ServerResponse } from 'src/app/shared/models/dto/server-response.dto';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CommonService {

  constructor(private httpClient: HttpClient) { }

  getStpMainInfoByStpMainIds(data: number[]): Observable<ServerResponse> {
    return this.httpClient.post<ServerResponse>(`${applicationUrls.user.readStpMainInfoByStpMainIds}`, { stpMainIds: data });
  }

  getRegularCertificateByEncryptedId(id: any): any {
    const userId = encodeURIComponent(id ?? "");
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.rpl.getCertificateDataForRegularCandidate}` + "?id=" + userId)
      .pipe(
        map((serverResponse: any) => {
          if (!serverResponse.data) {
            return [];
          }
          return serverResponse.data;
        }),
        tap((result: any) => {
          return result.data;
        })
      );
  }

  readTamMains(
    occupationName: string,
    tamType?: number,
  ): Observable<ServerResponse> {
    let url = applicationUrls.commonService.common.readTamMains;
    if (occupationName && tamType) {
      url += '?occupationName=' + occupationName + '&tamType=' + tamType;
    } else if (occupationName) {
      url += '?occupationName=' + occupationName;
    } else if (tamType) {
      url += '?tamType=' + tamType;
    }
    return this.httpClient.get<ServerResponse>(url).pipe(
      map((serverResponse: ServerResponse) => {
        return serverResponse;
      }),
    );
  }

  // notification-service reads the logged-in user from the token.
  getUnreadNotificationCount(): Observable<ServerResponse> {
    return this.httpClient.get<ServerResponse>(applicationUrls.commonService.getUnreadNotificationCount);
  }

  getNotificationsByModule(moduleId: number, page: number = 0, size: number = 10): Observable<ServerResponse> {
    const url = applicationUrls.commonService.getNotificationsByModule
      .replace('{moduleId}', moduleId.toString());
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
    return this.httpClient.get<ServerResponse>(url, {params});
  }


  markAsRead(data: { ids: number[]; moduleId: number }): Observable<ServerResponse> {
    return this.httpClient.put<ServerResponse>(applicationUrls.notifications.markAsReadUnified, data);
  }

  //#region jasper report
  readAttendanceAndResultSheetData(
    assessApplyId: number,
    assessorRefId: number,
  ): Observable<ServerResponse> {
    let params = new HttpParams().append('assessApplyId', `${assessApplyId}`);
    
    if (assessorRefId != null && Number.isFinite(assessorRefId)) {
      params = params.append('assessorRefId', `${assessorRefId}`);

      return this.httpClient.get<ServerResponse>(
        `${applicationUrls.common.readAttendanceAndResultSheetInfo}`,
        { params },
      );
    }
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.common.readRplIndAttendanceAndResultSheetInfo}`,
      { params },
    );
  }
}
